import builder from '../builder';
import PeopleMan8 from '../../streamline-icons/light/people-man-8.svg';

export default builder('IconPeopleMan8Light', PeopleMan8);
